import { CommonModule } from '@angular/common';
import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, FormsModule, ReactiveFormsModule } from '@angular/forms';
import { Router } from '@angular/router';
import { NzButtonModule } from 'ng-zorro-antd/button';
import { NzCardModule } from 'ng-zorro-antd/card';
import { NzFormModule } from 'ng-zorro-antd/form';
import { NzGridModule } from 'ng-zorro-antd/grid';
import { NzIconModule } from 'ng-zorro-antd/icon';
import { NzInputModule } from 'ng-zorro-antd/input';
import { NzSelectModule } from 'ng-zorro-antd/select';
import { ReferralDataService } from '../../../services/referral-data.service';
import { SectionsService } from '../../../services/sections.service';
import { ButtonComponent } from '@ppl/ui';
import { RoutingService } from '../../../shared/services/routing.service';
import { BaseComponent } from '../../../shared/utils/base.component';
import { performValidation } from '../../../shared/utils/validation.util';
import { NzAriaLabelDirective } from '../../../shared/directives/nz-aria-label.directive';
import { UserService } from '../../../services/user.service';
import { DropdownSelectComponent } from '@ppl/ui';
import { NzCheckboxModule } from 'ng-zorro-antd/checkbox';
import { AutoFocusFirstInputDirective } from '../../../shared/directives/auto-focus-first-input.directive';

@Component({
  selector: 'ppl-referral-logic',
  standalone: true,
  imports: [
    NzCardModule,
    NzGridModule,
    NzIconModule,
    NzInputModule,
    NzButtonModule,
    NzSelectModule,
    FormsModule,
    NzFormModule,
    ReactiveFormsModule,
    CommonModule,
    ButtonComponent,
    DropdownSelectComponent,
    NzCheckboxModule,
  ],
  templateUrl: './referral-logic.component.html',
  styleUrl: './referral-logic.component.css'
})
export class ReferralLogicComponent extends BaseComponent implements OnInit {

  state: string | null = null;
  logicForm!: FormGroup;
  flow: string | null = '';
  buttonText = '';

  states: any[] = [];
  providerTypes: any[] = [];

  constructor(private fb: FormBuilder, private sectionsService: SectionsService,
    private router: Router, private referralDataService: ReferralDataService,
    private userService: UserService, private routingService: RoutingService
  ) {
    super();
  }

  ngOnInit(): void {
    this.logicForm = this.fb.group({
      state: [''],
      providerType: [[]]
    });

    const program = this.userService.getSelectedProgram();
    this.flow = this.sectionsService.getFlow() ?? '';

    if (this.flow === 'providers') {
      this.providerTypes = [
        {label: 'Independent Provider', value: 'IP', disabled: false},
        {label: 'Independent Contractor', value: 'IC', disabled: false},
        {label: 'Vendor', value: 'Vendor', disabled: false}
      ];
    }

    this.secData = this.sectionsService.getStep1(program?.program_code).pre_referral_step1;
    this.states = this.getLookup("STATE");
    
    // selecting california as default state.
    this.logicForm.get('state')?.setValue(this.states.find(s => s.lkpValueCode === 'CA')?.lkpValueCode || '');
    this.buttonText = (this.flow == 'participants') ? 'Begin Participant Interest Submission' :
      'Begin Provider Interest Submission'
  }

  onBegin() {
    this.referralDataService.setReferralFormData('state', this.logicForm.value);

    if (this.flow === 'providers') {
      this.referralDataService.setReferralFormData('providerType', this.logicForm.value.providerType);
    }

    this.validationErrors = performValidation(this.logicForm.value, this.secData, 'Next', undefined, undefined, this.sectionsService.getFlow(), this.sectionsService.getEnrollmentType());
    if (this.flow !== 'providers') {
      if (!this.validationErrors.state) {
        this.router.navigate(['/newReferral'])
      }
    }
    else {
      if (!this.validationErrors.state && !this.validationErrors.providerType) {
        this.router.navigate(['/newReferral'])
      }
    }
  }

  onProviderTypeChange(isChecked: any, value: any){
    const selectedOptions = this.logicForm.get('providerType')?.value || [];
    if (isChecked) {
      if (value === 'Vendor'){
        // if vendor is selected we need to deselect IP and IC option if they are selected.
        const ICIndex = selectedOptions.indexOf('IC');
        const IPIndex = selectedOptions.indexOf('IP');
        if (ICIndex > -1){
          selectedOptions.splice(ICIndex, 1);
        }

        if (IPIndex > -1){
          selectedOptions.splice(IPIndex, 1);
        }
      }

      if (!selectedOptions.includes(value)) {
        selectedOptions.push(value);
      }
    } else {
      const index = selectedOptions.indexOf(value);
      if (index > -1) {
        selectedOptions.splice(index, 1);
      }
    }

    this.providerTypes.forEach(pt => {
      // if we select vendor we need to disable checkbox for other two.
      if (selectedOptions.includes('Vendor') && pt.value !== 'Vendor'){
        pt.disabled = true;
      }else{
        pt.disabled = false;
      }
    });

    this.logicForm.get('providerType')?.setValue(selectedOptions);
  }
  
  returnClicked(): void {
    this.routingService.navigateBack();
  }
}
